import { IOrderDraftResponse, IValidatedBasket } from '~/lib/data-contract';

export const updateOrderDraftBasket = (basket: IValidatedBasket) => (prev?: IOrderDraftResponse) => {
	if (!prev) {
		return prev;
	}
	return { ...prev, basket };
};
